import { useEffect, useState } from 'react';
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';
import './PrimarySkillsFilter.css';

export default function PrimarySkillsFilter({courseList,filteredData,setFilteredData,skillType}) {                    
  const [filterShow, setFilterShow] = useState(false);   
  const [searchTerm, setSearchTerm] = useState('');
  const [selectAll, setSelectAll] = useState(true); 
  const [selectedOptions, setSelectedOptions] = useState([]);         
  const [optionsData, setOptionsData] = useState([]);         
  
  // let filteredUserData = courseList.map(item => item.primarySkills === null ? {...item, primarySkills: 'null'} : item)
  let filteredUserData = courseList.filter(item => (item.primarySkills !== null))           
  filteredUserData = filteredUserData.map(item => item.secondarySkills === null ? {...item, secondarySkills: 'null'} : item)
  
  let primarySkills = filteredUserData.map(item => item.primarySkills)  
  let secondarySkills = filteredUserData.map(item => item.secondarySkills)
  let requesterId = filteredUserData.map(item => item.nominatedBy)           

  primarySkills = primarySkills.filter((value, index, array) => {
    return array.indexOf(value) === index;
  })    

  secondarySkills = secondarySkills.filter((value, index, array) => {
    return array.indexOf(value) === index;
  })

  requesterId = requesterId.filter((value, index, array) => {
    return array.indexOf(value) === index;
  })

  useEffect(() => {                         
    if(skillType === 'primary') {
      setOptionsData(primarySkills)
      setSelectedOptions(primarySkills)
    } else if(skillType === 'secondary') {
      setOptionsData(secondarySkills);
      setSelectedOptions(secondarySkills);
    } else if(skillType === 'requester_id') {
      setOptionsData(requesterId);
      setSelectedOptions(requesterId);
    }
  },[])  

  const handleFilterShow = (e) =>  {
    setFilterShow(!filterShow)       
  }  

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);    
    let filteredOptions = [];
    filteredOptions = ((skillType === 'primary' && primarySkills)  || (skillType === 'secondary' && secondarySkills)
    || (skillType === 'requester_id' && requesterId))
    .filter((option) => option.toLowerCase().includes(e.target.value.toLowerCase()));    
    setOptionsData(filteredOptions);
  };  

  const handleCheckboxChange = (e,option) => {                    
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
    
    if(skillType === 'primary') {
      !e.target.checked && setFilteredData(filteredData.filter(item => item.primarySkills !== option))
      if(e.target.checked) {
        let data = filteredUserData.filter(item => item.primarySkills === option);                                          
          setFilteredData(filteredData => [...filteredData , ...data]);                                  
      }
    } else if(skillType === 'secondary') {
      !e.target.checked && setFilteredData(filteredData.filter(item => item.secondarySkills !== option))
      if(e.target.checked) {          
        let data = filteredUserData.filter(item => item.secondarySkills === option);                        
        setFilteredData(filteredData => [...filteredData , ...data]);
      }
    } else if(skillType === 'requester_id') {
      !e.target.checked && setFilteredData(filteredData.filter(item => item.nominatedBy !== option))
      if(e.target.checked) {          
        let data = filteredUserData.filter(item => item.nominatedBy === option);                        
        setFilteredData(filteredData => [...filteredData , ...data]);
      }
    }    
  };            

  function handleCheckboxSelectAllChange(e) {
    setSelectAll(!selectAll);    
    if(skillType === 'primary') {
      if(!selectAll) {        
        if(searchTerm === '') {
          setSelectedOptions(primarySkills);
          setFilteredData(filteredUserData);
        } else {
          setSelectedOptions(optionsData);
          const filteredOptions = filteredUserData.filter((obj) => optionsData.includes(obj.primarySkills));              
          setFilteredData(filteredOptions);
        }
      } else {
        setSelectedOptions([]);
        setFilteredData([]);
      }
    } else if(skillType === 'secondary') {
      if(!selectAll) {
        if(searchTerm === '') {
          setSelectedOptions(secondarySkills);
          setFilteredData(filteredUserData);
        } else {
          setSelectedOptions(optionsData);
          const filteredOptions = filteredUserData.filter((obj) => optionsData.includes(obj.secondarySkills));              
          setFilteredData(filteredOptions);
        }        
      } else {
        setSelectedOptions([]);
        setFilteredData([]);
      }         
    } else if(skillType === 'requester_id') {
      if(!selectAll) {
        if(searchTerm === '') {
          setSelectedOptions(requesterId);
          setFilteredData(filteredUserData);
        } else {
          setSelectedOptions(optionsData);
          const filteredOptions = filteredUserData.filter((obj) => optionsData.includes(obj.nominatedBy));              
          setFilteredData(filteredOptions);
        }        
      } else {
        setSelectedOptions([]);
        setFilteredData([]);
      }         
    }      
  }
    
  return <>        
    <FilterAltTwoToneIcon onClick={handleFilterShow} sx={{cursor: 'pointer','vertical-align': 'bottom','font-size': '25px','margin-left': '6px'}}/>           
    {/* {filteredUserData.length !== filteredData.length && optionsData.length !== selectedOptions.length  && <FilterAltOffTwoToneIcon onClick={handleFilterClean} sx={{cursor: 'pointer','vertical-align': 'bottom','font-size': '25px','margin-left': '6px'}}/>}                */}
    {filterShow && <div className="primary_skill_filter">      
        <span class="arrow-up"></span>
        <div className="filter-section">
          <div className="search_container">        
            <input type="text" className="search_input" placeholder="&nbsp;&nbsp;Search..." value={searchTerm} onChange={handleSearch} onClick={(e) => e.stopPropagation()} />        
          </div>      
            <label className="select-all-option-label">
              <input type="checkbox" checked={selectAll} onChange={(e) => handleCheckboxSelectAllChange(e)} /> Select All
            </label>            
          {optionsData.map((option, index) => (
            <label key={index} className="option-label">
              <input type="checkbox" checked={selectedOptions.includes(option)} onChange={(e) => handleCheckboxChange(e,option)} />
              &nbsp;{option}
            </label>
          ))}
        </div>
      </div>}
  </>
}